module.exports = __webpack_public_path__ + "static/media/settings.5fa3e9f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings.png
// module id = 40
// module chunks = 0